import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

export const FormTitle = styled(Typography)({
  fontFamily: 'Roboto',
  fontWeight: 500,
  color: '#0E335C',
  fontSize: 14,
  paddingBottom: 0
});

export default FormTitle;
